import React, { useEffect, useState } from "react";
import KycImageActive from './images/placeholder Fill (4).png'
import messageInctive from './images/placeholder Fill (14).png'
import legalactive from './images/placeholder Fill (15).png'
import SalaryActive from './images/placeholder Fill (16).png'
import legalInactive from './images/placeholder Fill (17).png'
import SalaryInctive from './images/placeholder Fill (18).png'
import EmiActive from './images/placeholder Fill (16).png'
import EmInactive from './images/placeholder Fill (18).png'
import TxnActive from './images/placeholder Fill (4).png'
import TxninActive from './images/placeholder Fill (14).png'
import Nodata from '../../../../images/nodata.png'

import { getNotesnewTenantNew, getSmsAnalysisStatusWithRegenerateNew, saveCommentForCreditAssesmentNew,getUserLocationById,getUserConactsById,getUserCallLogsById } from "../Analysis/analysisactionCreator";
import { APIS } from "../../../../utils/api-factory";
import ALLTxNSms from './allsmstransaction'
import { Pagination } from "@mui/material";
import RawMsg from "../CustomerPages/RawMsg.container";
import { saveUnderWriterApiNew } from "../AdminActionCreator.component";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
// import Loader from '../../../presentationals/Loader/Loader.component'

let paginationNumber = 10
let jsondata = {};

const SmsAnalysis = ({ allDetail, sendDataToMainPage, smsJson, admin, customHeaderTenant, customHeaderPOSTTenant }) => {
    const [filterType, setfilterType] = useState('Overdue')
    const [smsData, setSmsData] = useState('')
    const [tableMinPagination, settableMinPagination] = useState(0)
    const [tableMaxPagination, settableMaxPagination] = useState(paginationNumber)
    const [msgData, setMessageData] = useState('')
    const [pageNumber, setpageNumber] = useState(1)
    const [underWriterStatus, setunderWriterStatus] = useState('')
    const [popupStatus, setpopupStatus] = useState('')
    const [sidePoupState, setsidePoupState] = useState('')
    const [newNotes, setnewNotes] = useState('')
    const [notesType, setNotesType] = useState('')
    const [notesPopup, setNotesPopup] = useState(false)
    const [notesText, setNotesText] = useState('')
    const [loaderState, setloaderState] = useState(false)
    const [regenerate, setregenerate] = useState(0)

    // New State for Tabs & Call Logs
    const [activeMainTab, setActiveMainTab] = useState('sms')
    const [hoveredTab, setHoveredTab] = useState(null)
    
    // Call Logs Tab State
    const [callLogsData, setCallLogsData] = useState(null)
    const [callLogsLoader, setCallLogsLoader] = useState(false)
    const [callLogSearch, setCallLogSearch] = useState('')
    const [callLogPage, setCallLogPage] = useState(1)
    const callLogPageSize = 10

    // Contacts Tab State
    const [contactsData, setContactsData] = useState(null)
    const [contactsLoader, setContactsLoader] = useState(false)
    const [contactSearch, setContactSearch] = useState('')
    const [contactPage, setContactPage] = useState(1)
    const contactPageSize = 10

    // Location Tab State
    const [locationData, setLocationData] = useState([])
    const [locationLoader, setLocationLoader] = useState(false)
    const [locationSearch, setLocationSearch] = useState('')
    const [locationPage, setLocationPage] = useState(1)
    const locationPageSize = 10

    // Reverse Geocoding Cache
    const [resolvedAddresses, setResolvedAddresses] = useState({})

    const fetchLocationData = () => {
        setLocationLoader(true);
        getUserLocationById(allDetail.userId, customHeaderTenant, callback => {
            setLocationLoader(false);
            if (callback && Array.isArray(callback)) {
                setLocationData(callback);
            } else if (callback && Array.isArray(callback.data)) {
                setLocationData(callback.data);
            } else {
                setLocationData([]);
            }
        });
    };

    const fetchContactsPage = (pageNo) => {
        setContactsLoader(true);
        getUserConactsById(allDetail.userId, pageNo, 10, callback => {
            setContactsLoader(false);
            if (callback) {
                setContactsData(callback);
            } else {
                setContactsData({ data: [], totalCount: 0, totalPages: 0, page: pageNo });
            }
        });
    };

    const fetchCallLogsPage = (pageNo) => {
        setCallLogsLoader(true);
        getUserCallLogsById(allDetail.userId, pageNo, 10, callback => {
            setCallLogsLoader(false);
            if (callback) {
                setCallLogsData(callback);
            } else {
                setCallLogsData({ data: [], totalCount: 0, totalPages: 0, page: pageNo });
            }
        });
    };

    useEffect(() => {
        if (activeMainTab === 'location') {
            fetchLocationData();
        } else if (activeMainTab === 'contacts') {
            fetchContactsPage(contactPage);
        } else if (activeMainTab === 'callLogs') {
            fetchCallLogsPage(callLogPage);
        }
    }, [activeMainTab, contactPage, callLogPage]);

    const fetchAddressManually = (lat, lon) => {
        const key = `${lat}_${lon}`;
        setResolvedAddresses(prev => ({ ...prev, [key]: 'Fetching...' }));
        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`, {
            headers: { 'User-Agent': 'PhocketAdmin/1.0' }
        })
        .then(res => res.json())
        .then(data => {
            const addrStr = data.display_name || `${lat}, ${lon}`;
            setResolvedAddresses(p => ({ ...p, [key]: addrStr }));
        })
        .catch(err => {
            setResolvedAddresses(p => ({ ...p, [key]: 'Error fetching address' }));
        });
    };

    // Geocode current page of locations sequentially to avoid OSM block
    useEffect(() => {
        if (activeMainTab !== 'location' || !locationData || locationData.length === 0) return;

        // Filter locations based on search term
        const filtered = locationData.filter(item => {
            const lat = item.latitude || '';
            const lon = item.longitude || '';
            const date = item.date || '';
            const addr = item.address || resolvedAddresses[`${lat}_${lon}`] || '';
            const term = locationSearch.toLowerCase();
            return lat.toString().toLowerCase().includes(term) || 
                   lon.toString().toLowerCase().includes(term) || 
                   date.toString().toLowerCase().includes(term) ||
                   addr.toString().toLowerCase().includes(term);
        });

        // Slice current page
        const paginated = filtered.slice(
            (locationPage - 1) * locationPageSize,
            locationPage * locationPageSize
        );
        
        const timers = [];
        let delay = 0;
        paginated.forEach(item => {
            const lat = item.latitude;
            const lon = item.longitude;
            if (!lat || !lon) return;
            const key = `${lat}_${lon}`;
            
            // Check if address is null/empty in response and we haven't fetched it yet
            if ((!item.address || item.address === 'null') && !resolvedAddresses[key]) {
                const t = setTimeout(() => {
                    setResolvedAddresses(prev => {
                        // Guard against duplicate fetch
                        if (prev[key]) return prev;
                        
                        // Set intermediate loading state
                        setResolvedAddresses(p => ({ ...p, [key]: 'Fetching...' }));

                        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`, {
                            headers: { 'User-Agent': 'PhocketAdmin/1.0' }
                        })
                        .then(res => {
                            if (!res.ok) throw new Error('OSM Rate Limit / Error');
                            return res.json();
                        })
                        .then(data => {
                            const addrStr = data.display_name || `${lat}, ${lon}`;
                            setResolvedAddresses(p => ({ ...p, [key]: addrStr }));
                        })
                        .catch(err => {
                            console.error("OSM geocoding failed, trying fallback:", err);
                            setResolvedAddresses(p => ({ ...p, [key]: 'Click to fetch' }));
                        });
                        
                        return prev;
                    });
                }, delay);
                
                timers.push(t);
                delay += 1500; // Stagger by 1.5 seconds to respect Nominatim TOS (1 req/s limit)
            }
        });

        return () => {
            timers.forEach(t => clearTimeout(t));
        };
    }, [locationPage, locationSearch, activeMainTab, locationData]);

    const getCallLogFields = (item) => {
        if (!item) return { contact: 'N/A', type: 'N/A', duration: 'N/A', date: 'N/A' };
        if (typeof item === 'string') {
            return { contact: item, type: 'N/A', duration: 'N/A', date: 'N/A' };
        }
        const name = item.name || item.contactName || item.displayName || '';
        const number = item.number || item.phoneNumber || item.phone || item.mobile || item.mobileNo || '';
        const contact = name ? `${name} (${number})` : (number || 'N/A');
        
        const type = item.type || item.callType || item.call_type || 'N/A';
        const duration = item.duration || item.callDuration || item.call_duration || 'N/A';
        const date = item.date || item.dateTime || item.time || item.timestamp || item.callDate || 'N/A';
        
        return { contact, type, duration, date };
    };

    const formatCallDate = (dateVal) => {
        if (!dateVal || dateVal === 'N/A') return 'N/A';
        const parsedNum = Number(dateVal);
        if (!isNaN(parsedNum) && dateVal.toString().length >= 10) {
            return moment(parsedNum).format('DD-MM-YYYY hh:mm A');
        }
        const m = moment(dateVal);
        if (m.isValid()) {
            return m.format('DD-MM-YYYY hh:mm A');
        }
        return dateVal;
    };

    const getTabStyle = (tabName) => {
        const isActive = activeMainTab === tabName;
        const isHovered = hoveredTab === tabName;
        return {
            padding: '12px 24px',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            borderBottom: isActive ? '3px solid #2B78FF' : '3px solid transparent',
            color: isActive ? '#2B78FF' : isHovered ? '#1D4ED8' : '#555555',
            fontWeight: isActive ? '700' : '500',
            fontSize: '15px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            transform: isHovered ? 'translateY(-1px)' : 'none',
            textDecoration: 'none'
        };
    };

    const smsTabHandler = (type) => {
        settableMinPagination(0)
        settableMaxPagination(10)
        setfilterType(type)
    }
    const getSmsAnalysisStatusData = (param) => {
        setloaderState(true)
        getSmsAnalysisStatusWithRegenerateNew(allDetail.userId, param,customHeaderTenant, callback => {
            setSmsData(callback)
            setloaderState(false)

        })
    }
    useEffect(() => {
        getSmsAnalysisStatusData(0)
        jsondata = smsJson

    }, [])
    const regenerateSms = () => {
        setloaderState(true)
        getSmsAnalysisStatusWithRegenerateNew(allDetail.userId, 1,customHeaderTenant, callback => {
            setSmsData(callback)
            setloaderState(false)

        })
    }
    const phocketTablePagination = (data, type) => {
        if (type == 'back') {
            if (tableMinPagination >= paginationNumber) {
                settableMinPagination(tableMinPagination - paginationNumber)
                settableMaxPagination(tableMaxPagination - paginationNumber)


            }
        } else if (type == 'forward') {
            if (tableMaxPagination < data.length) {
                settableMinPagination(tableMinPagination + paginationNumber)
                settableMaxPagination(tableMaxPagination + paginationNumber)

            }
        }
    }
    const handleChangeNewPagination = (e, value) => {
        setpageNumber(value)
        const newMinPagination = (value - 1) * paginationNumber;
        const newMaxPagination = value * paginationNumber;
        settableMaxPagination(newMaxPagination)
        settableMinPagination(newMinPagination)

    };
    const smsJsonData = (data, value) => {
        if (jsondata.hasOwnProperty(data)) {
            const index = jsondata[data].indexOf(value);
            if (index !== -1) {
                jsondata[data].splice(index, 1);
            } else {
                jsondata[data].push(value);
            }
        } else {
            jsondata[data] = [value];
        }

        sendDataToMainPage(jsondata)

    };

    // const smsJsonData = (data, value) => {
    //     let jsondata = {};

    //     if (jsondata.hasOwnProperty(data)) {
    //         jsondata[data].push(value);
    //     } else {
    //         jsondata[data] = [value];
    //     }

    // }



    const commentChangeHandler = (e, type) => {
        if (e.target.value !== 'add') {
            setNotesText(e.target.value)
        }
        if (e.target.value === 'add') {
            setNotesPopup(true)
            setNotesText(e.target.value)

        }
        setNotesType(type)

    }
    const saveNotesType = () => {
        if (notesText !== '' && notesText !== undefined && notesText !== null) {
            saveCommentForCreditAssesmentNew(allDetail.loanId, allDetail.userId, notesText, admin.emailId, filterType,customHeaderPOSTTenant, callBack => {
                setNotesPopup(false)
                if (callBack === 'success') {
                    getNotesnewTenantNew(allDetail.loanId, allDetail.userId, filterType,customHeaderPOSTTenant, callBack => {
                        setnewNotes(callBack)
                    })
                }

            })
        }
    }

    const saveUnderWritter = (type) => {
        let decisionType = 'smsAnalysisDecision'
        if (underWriterStatus !== '' && decisionType !== '') {
            saveUnderWriterApiNew(decisionType, allDetail, underWriterStatus, admin,customHeaderPOSTTenant, callBack => {

                if (callBack === 'success') {
                    setunderWriterStatus('')
                    setpopupStatus('successfully saved !')
                    setsidePoupState(true)
                    removePopup()

                } else {
                    setpopupStatus('please try again later !')
                    setsidePoupState(true)
                    removePopup()
                }
            })
        } else {
            setpopupStatus('Please select value !')
            setsidePoupState(true)
            removePopup()
        }
    }
    const removePopup = () => {
        setTimeout(() => {
            setsidePoupState(false)
        }, 5000);
    }
    const underWriterHandler = (e) => {
        setunderWriterStatus(e.target.value)
    }
    const closepopupSide = () => {
        setsidePoupState(false)

    }
    const openCommentPopup = (data) => {
        setNotesPopup(true)
        setNotesType(data)
        getNotesnewTenantNew(allDetail.loanId, allDetail.userId, data,customHeaderPOSTTenant, callBack => {
            setnewNotes(callBack)
        })

    }
    const closepopup = () => {
        setNotesPopup(false)
        setNotesText('')
        setnewNotes('')
    }
    return (
        <>
            {/* {loaderState ?
                <Loader />
                : ""} */}
            {notesPopup ?
                <div className="background-blur">

                    <div className="popup-main small-popup container-fluid max-width-500px  " style={{ padding: '20px', borderRadius: '10px' }}>
                        <i onClick={() => closepopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                        <div className="row from-group">
                            <div className="col-xs-12" style={{ padding: '10px' }}>
                                <h5 className="" style={{ marginBottom: '10px', marginTop: '10px', fontWeight: '700' }}><i style={{ fontWeight: '700' }} className='fa fa-commenting-o'></i>&nbsp;&nbsp; Comment</h5>
                            </div>
                        </div>
                        <div style={{ background: '#F1F7FF', border: '1px solid #DBE9FF', padding: '10px', borderRadius: '12px' }}>
                            Status : { }
                            <hr />
                            <textarea className='form-control' placeholder='type here...' onChange={(e) => commentChangeHandler(e, notesType)} />
                            <div className='text-right'>
                                <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => saveNotesType()}>Save</button>
                            </div>
                        </div>
                        {newNotes !== '' && newNotes.length > 0 ? <h5 style={{ fontWeight: '700' }}> Previous Comments</h5> : ""}
                        {newNotes !== '' && newNotes.length > 0 ?
                            <div style={{
                                borderRadius: '10px',
                                border: '1px solid #D1D9E2',
                                background: '#fff',
                                maxHeight: '200px',
                                overflowY: 'scroll'
                            }}>

                                {newNotes.map((data, i) => {
                                    return (
                                        <div className='container-fluid'>
                                            <div className='row' style={{ borderBottom: '1px solid #D1D9E2', padding: '10px' }} key={i}>
                                                <div className='col-sm-6 col-xs-6'>
                                                    {data.notes}<br />
                                                    <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '10px' }}>{data.empId}</span>
                                                </div>
                                                <div className='col-sm-6 col-xs-6 text-right'>
                                                    <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '10px' }}>{data.addedOn ? moment(data.addedOn).format('DD-MM-YYYY') : ""}</span>
                                                </div>

                                            </div>
                                            {/* <hr /> */}
                                        </div>
                                    )
                                })}
                            </div>
                            : ""}

                    </div>
                </div>
                : ""}
            <div className=" details-body-credit full-height credit-module" style={{ padding: '15px' }}>
                {/* Modern 4-Tab Navigation */}
                <div style={{
                    display: 'flex',
                    borderBottom: '2px solid #EAEAEA',
                    marginBottom: '20px',
                    gap: '10px'
                }}>
                    <button
                        onClick={() => setActiveMainTab('sms')}
                        onMouseEnter={() => setHoveredTab('sms')}
                        onMouseLeave={() => setHoveredTab(null)}
                        style={getTabStyle('sms')}
                    >
                        <i className="fa fa-envelope-o" style={{ marginRight: '8px' }}></i>SMS Analysis
                    </button>
                    <button
                        onClick={() => setActiveMainTab('location')}
                        onMouseEnter={() => setHoveredTab('location')}
                        onMouseLeave={() => setHoveredTab(null)}
                        style={getTabStyle('location')}
                    >
                        <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i>Location
                    </button>
                    <button
                        onClick={() => setActiveMainTab('contacts')}
                        onMouseEnter={() => setHoveredTab('contacts')}
                        onMouseLeave={() => setHoveredTab(null)}
                        style={getTabStyle('contacts')}
                    >
                        <i className="fa fa-address-book-o" style={{ marginRight: '8px' }}></i>Contacts
                    </button>
                    <button
                        onClick={() => setActiveMainTab('callLogs')}
                        onMouseEnter={() => setHoveredTab('callLogs')}
                        onMouseLeave={() => setHoveredTab(null)}
                        style={getTabStyle('callLogs')}
                    >
                        <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>Call Logs
                    </button>
                </div>

                {/* Tab Contents */}
                {activeMainTab === 'sms' && (
                    <div className="row">
                        <div className="col-sm-3 col-xs-12">
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'Overdue' ? KycImageActive : messageInctive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('Overdue')} style={{ fontSize: '14px', cursor: 'pointer', color: filterType === 'Overdue' ? '#2B78FF' : '#000', fontWeight: filterType === 'Overdue' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'Overdue' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'Overdue' ? '700' : '400' }}> Overdue SMS</span>
                                    <br />
                                    {smsData && smsData.overDue ? <div style={{ marginBottom: '3.5px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}><b>{smsData.overDueMsg.length}</b> &nbsp;Found </div> :
                                        ""}
                                </div>

                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'Emi' ? EmiActive : EmInactive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('Emi')} style={{ fontSize: '14px', cursor: 'pointer', color: filterType === 'Emi' ? '#2B78FF' : '#000', fontWeight: filterType === 'Emi' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'Emi' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'Emi' ? '700' : '400' }}> EMI Amount</span>
                                    <br />
                                    {smsData && smsData.totalEmiAmt ? <span style={{ fontSize: '12px', color: '#2B78FF' }}>INR {smsData ? Math.round(smsData.totalEmiAmt) : ''}</span> : ""}
                                    {smsData && smsData.emiMsg ? <div style={{ marginBottom: '3.5px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}><b>{smsData.emiMsg.length}</b> &nbsp;Found </div> :
                                        ""}
                                </div>

                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'Legal' ? legalactive : legalInactive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('Legal')} style={{ fontSize: '14px', cursor: 'pointer', color: filterType === 'Legal' ? '#2B78FF' : '#000', fontWeight: filterType === 'Legal' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'Legal' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'Legal' ? '700' : '400' }}> Legal SMS</span>
                                    <br />
                                    {smsData && smsData.legal ? <div style={{ marginBottom: '3.5px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}><b>{smsData.legalMsg.length}</b> &nbsp;Found </div> :
                                        ""}            </div>

                            </div>

                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'Salary' ? SalaryActive : SalaryInctive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('Salary')} style={{ fontSize: '14px', cursor: 'pointer', color: filterType === 'Salary' ? '#2B78FF' : '#000', fontWeight: filterType === 'Salary' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'Salary' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'Salary' ? '700' : '400' }}> Salary</span>
                                    <br />
                                    {smsData && smsData.salary ? <span style={{ fontSize: '12px', color: '#2B78FF' }}>INR {smsData ? Math.round(smsData.salary) : ''}</span> : ""}
                                    {smsData && smsData.salaryMsg
                                        ? <div style={{ marginBottom: '3.5px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}><b>{smsData.salaryMsg
                                            .length}</b> &nbsp;Found </div> :
                                        ""}
                                </div>

                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'Transaction' ? TxnActive : TxninActive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('Transaction')} style={{ marginTop: '5px', fontSize: '14px', cursor: 'pointer', color: filterType === 'Transaction' ? '#2B78FF' : '#000', fontWeight: filterType === 'Transaction' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'Transaction' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'Transaction' ? '700' : '400' }}>   Transaction Messages</span>

                                </div>

                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-4 text-right">
                                    <img src={filterType === 'viewall' ? TxnActive : TxninActive} width={'32px'} />
                                </div>
                                <div className="col-sm-8" onClick={() => smsTabHandler('viewall')} style={{ marginTop: '5px', fontSize: '14px', cursor: 'pointer', color: filterType === 'viewall' ? '#2B78FF' : '#000', fontWeight: filterType === 'viewall' ? '700' : '400' }}>
                                    <span style={{ color: filterType === 'viewall' ? '#267DFF' : 'rgba(0, 0, 0, 0.45)', fontWeight: filterType === 'viewall' ? '700' : '400' }}>   Detailed View</span>

                                </div>

                            </div>

                        </div>
                        <div className="col-sm-9 col-xs-12" style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.25)', height: '600px', overflow: 'auto' }}>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-6 col-xs-12">
                                    <h4 style={{ color: 'rgba(0, 0, 0, 0.80)' }}><i className="fa fa-server" aria-hidden="true"></i>&nbsp;&nbsp;{filterType} &nbsp;SMS List</h4>
                                </div>
                                <div className="col-sm-6 col-xs-12 text-right">
                                    <button className="reset-btn" style={{ marginTop: '0', marginRight: '10px' }} onClick={() => regenerateSms()}>Regenerate</button>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-sm-6 col-xs-6"></div>
                                <div className="col-sm-6 col-xs-6">
                                    {filterType === 'Transaction' ?
                                        <div style={{ float: 'inline-end', marginTop: '-15px' }} >
                                            <span onClick={() => openCommentPopup(filterType)} style={{ color: '#267DFF', fontWeight: '700', cursor: 'pointer' }}><i className='fa fa-commenting-o'></i>&nbsp;&nbsp;Comment&nbsp;&nbsp;</span>

                                            <select className="" style={{ padding: '10px', border: '1px solid #D3D9E9', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }} onChange={(e) => underWriterHandler(e, 'aadhaar')} >
                                                <option value={''}>Select Option</option>
                                                <option value={'Legal SMS Found'}>Legal SMS Found</option>
                                                <option value={'Overdue SMS Found'}>Overdue SMS Found</option>
                                                <option value={'Overdue SMS Not Found'}>Overdue SMS Not Found</option>
                                                <option value={'Legal SMS Not Found'}>Legal SMS Not Found</option>

                                            </select>
                                            <button className="btn btn-primary" style={{ marginTop: '17px', background: '#2B78FF', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} onClick={() => saveUnderWritter()}>Save</button>
                                        </div>
                                        : ""}
                                </div>

                            </div>
                            {smsData && loaderState === false && smsData.overDueMsg && filterType === 'Overdue' ?
                                <div>
                                    <div className='phocket-table-new'>
                                        <table>
                                            <thead>
                                                <tr className='thead-class'>
                                                    <th>Bank Name</th>
                                                    <th className="text-center">Message</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {smsData && smsData.overDueMsg ?
                                                    Object.entries(smsData.overDueMsg).slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                                        const messageType = data[1].message;

                                                        const isEmiIncluded = jsondata['OverDue'] && jsondata['OverDue'].some(item => item.message === messageType);

                                                        return (
                                                            <tr style={{
                                                                background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                                            }} key={i} onClick={() => smsJsonData('OverDue', data[1])}>
                                                                <td>{data[1].bankName}</td>
                                                                <td>{data[1].message}</td>
                                                                <td>{data[1].messageType}</td>
                                                                <td>{data[1].messageDate}</td>

                                                            </tr>
                                                        )
                                                    })
                                                    : ""}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="container-fluid">
                                        {/* <div className="row">
                                        <div className="col-sm-5 col-xs-12 no-padding"><button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block   " style={{ background: '#BADBF9', borderRadius: '0' }} onClick={e => phocketTablePagination(smsData.overDueMsg, 'back')}></button></div>
                                        <div className="col-sm-2 col-xs-12  phoc text-center" >
                                            {(tableMinPagination + 1) + ' - ' + (tableMaxPagination) + ' of ' + smsData.overDueMsg.length}
                                        </div>
                                        <div className="col-sm-5 col-xs-12 no-padding" ><button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block " o style={{ background: '#BADBF9', borderRadius: '0' }} onClick={e => phocketTablePagination(smsData.overDueMsg, 'forward')}></button></div>
                                    </div> */}
                                        <div className="" style={{ float: 'right', marginTop: '10px', marginBottom: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(smsData.overDueMsg.length / 5)}
                                                page={pageNumber}
                                                onChange={handleChangeNewPagination}
                                                color="success"
                                            // shape="rounded"
                                            />
                                        </div>
                                    </div>
                                </div>
                                : ""}
                            {smsData && loaderState === false && smsData.emiMsg && smsData.emiMsg.length > 0 && filterType === 'Emi' ?
                                <div>
                                    <div className='phocket-table-new'>
                                        <table>
                                            <thead>
                                                <tr className='thead-class'>
                                                    <th>Bank Name</th>
                                                    <th className="text-center">Message</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {smsData && smsData.emiMsg ?
                                                    Object.entries(smsData.emiMsg).slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                                        const messageType = data[1].message;

                                                        const isEmiIncluded = jsondata['Emi'] && jsondata['Emi'].some(item => item.message === messageType);

                                                        return (
                                                            <tr
                                                                style={{
                                                                    background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                                                }}
                                                                key={i} onClick={() => smsJsonData('Emi', data[1])}>
                                                                <td>{data[1].bankName}</td>
                                                                <td>{data[1].message}</td>
                                                                <td>{data[1].messageType}</td>
                                                                <td>{data[1].messageDate}</td>

                                                            </tr>
                                                        )
                                                    })
                                                    : ""}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="container-fluid">

                                        <div className="" style={{ float: 'right', marginTop: '10px', marginBottom: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(smsData.emiMsg.length / 5)}
                                                page={pageNumber}
                                                onChange={handleChangeNewPagination}
                                                color="success"
                                            // shape="rounded"
                                            />
                                        </div>
                                    </div>
                                </div>
                                : ''}
                            {smsData && loaderState === false && smsData.legal && smsData.legalMsg.length > 0 && filterType === 'Legal' ?
                                <div>
                                    <div className='phocket-table-new'>
                                        <table>
                                            <thead>
                                                <tr className='thead-class'>
                                                    <th>Bank Name</th>
                                                    <th className="text-center">Message</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {smsData && smsData.legalMsg ?
                                                    Object.entries(smsData.legalMsg).slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                                        const messageType = data[1].message;

                                                        const isEmiIncluded = jsondata['Legal'] && jsondata['Legal'].some(item => item.message === messageType);

                                                        return (
                                                            <tr
                                                                style={{
                                                                    background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                                                }}
                                                                key={i} onClick={() => smsJsonData('Legal', data[1])}>
                                                                <td>{data[1].bankName}</td>
                                                                <td>{data[1].message}</td>
                                                                <td>{data[1].messageType}</td>
                                                                <td>{data[1].messageDate}</td>

                                                            </tr>
                                                        )
                                                    })
                                                    : ""}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="container-fluid">

                                        <div className="" style={{ float: 'right', marginTop: '10px', marginBottom: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(smsData.legalMsg.length / 5)}
                                                page={pageNumber}
                                                onChange={handleChangeNewPagination}
                                                color="success"
                                            // shape="rounded"
                                            />
                                        </div>
                                    </div>
                                </div>
                                : ''}
                            {smsData && loaderState === false && smsData.salaryMsg && smsData.salaryMsg.length > 0 && filterType === 'Salary' ?
                                <div>
                                    <div className='phocket-table-new'>
                                        <table>
                                            <thead>
                                                <tr className='thead-class'>
                                                    <th>Bank Name</th>
                                                    <th className="text-center">Message</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {smsData && smsData.salaryMsg ?
                                                    Object.entries(smsData.salaryMsg).slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                                        const messageType = data[1].message;

                                                        const isEmiIncluded = jsondata['Salary'] && jsondata['Salary'].some(item => item.message === messageType);
                                                        return (
                                                            <tr
                                                                style={{
                                                                    background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                                                }}
                                                                key={i} onClick={() => smsJsonData('Salary', data[1])}>
                                                                <td>{data[1].bankName}</td>
                                                                <td>{data[1].message}</td>
                                                                <td>{data[1].messageType}</td>
                                                                <td>{data[1].messageDate}</td>

                                                            </tr>
                                                        )
                                                    })
                                                    : ""}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="container-fluid" style={{ float: 'right', marginTop: '10px', marginBottom: '20px' }}>

                                        <Pagination
                                            count={Math.ceil(smsData.salaryMsg.length / 5)}
                                            page={pageNumber}
                                            onChange={handleChangeNewPagination}
                                            color="success"
                                        // shape="rounded"
                                        />

                                    </div>
                                </div>
                                : ''}
                            {filterType === 'Transaction' ?
                                <ALLTxNSms allDetail={allDetail} msgData={msgData} />
                                : ""}
                            {filterType === 'viewall' ?
                                <RawMsg allDetail={allDetail} smsJsonData={smsJsonData} jsondata={jsondata} />
                                : ""}
                            {
                                loaderState ?
                                    <div className='phocket-table-new' style={{ overflow: 'auto' }} >
                                        <table className='text-center' style={{ marginTop: '0px' }}>
                                            <thead>
                                                <tr>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                    <th><Skeleton height={40} /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>

                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    : ""
                            }


                        </div>
                    </div>
                )}

                {activeMainTab === 'location' && (
                    <div className="animated fadeIn" style={{ padding: '15px' }}>
                        {locationLoader ? (
                            <div className="text-center" style={{ padding: '50px' }}>
                                <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ color: '#2B78FF' }}></i>
                                <p style={{ marginTop: '10px', color: '#555' }}>Loading Location Data...</p>
                            </div>
                        ) : (
                            <div>
                                {(() => {
                                    const locations = locationData || [];
                                    const filtered = locations.filter(item => {
                                        const lat = item.latitude || '';
                                        const lon = item.longitude || '';
                                        const date = item.date || '';
                                        const addr = item.address || resolvedAddresses[`${lat}_${lon}`] || '';
                                        const term = locationSearch.toLowerCase();
                                        return lat.toString().toLowerCase().includes(term) || 
                                               lon.toString().toLowerCase().includes(term) || 
                                               date.toString().toLowerCase().includes(term) ||
                                               addr.toString().toLowerCase().includes(term);
                                    });

                                    const paginated = filtered.slice(
                                        (locationPage - 1) * locationPageSize,
                                        locationPage * locationPageSize
                                    );

                                    return (
                                        <div>
                                            <div className="row" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search location history..."
                                                        value={locationSearch}
                                                        onChange={(e) => {
                                                            setLocationSearch(e.target.value);
                                                            setLocationPage(1);
                                                        }}
                                                        style={{
                                                            borderRadius: '8px',
                                                            border: '1px solid #D3D9E9',
                                                            padding: '10px 15px',
                                                            width: '100%',
                                                            maxWidth: '400px'
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-sm-6 text-right">
                                                    <span style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>
                                                        Total Points: <b>{filtered.length}</b>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="phocket-table-new">
                                                <table>
                                                    <thead>
                                                        <tr className="thead-class">
                                                            <th>Date</th>
                                                            <th>Coordinates (Lat, Lon)</th>
                                                            <th>Full Address</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paginated.length > 0 ? (
                                                            paginated.map((item, i) => {
                                                                const lat = item.latitude;
                                                                const lon = item.longitude;
                                                                const key = `${lat}_${lon}`;
                                                                const addr = item.address || resolvedAddresses[key] || '';
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ fontWeight: '600' }}>{item.date || 'N/A'}</td>
                                                                        <td>
                                                                            <span style={{ fontFamily: 'monospace', color: '#333' }}>
                                                                                {lat}, {lon}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            {addr === 'Fetching...' ? (
                                                                                <span style={{ color: '#2B78FF' }}>
                                                                                    <i className="fa fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>Geocoding...
                                                                                </span>
                                                                            ) : addr === 'Click to fetch' ? (
                                                                                <button 
                                                                                    className="btn btn-xs btn-link" 
                                                                                    onClick={() => fetchAddressManually(lat, lon)}
                                                                                    style={{ padding: 0, textDecoration: 'underline' }}
                                                                                >
                                                                                    Fetch Address
                                                                                </button>
                                                                            ) : addr ? (
                                                                                <span style={{ color: '#333' }}>{addr}</span>
                                                                            ) : (
                                                                                <span style={{ color: '#888', fontStyle: 'italic' }}>Pending...</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center" style={{ padding: '40px' }}>
                                                                    <img src={Nodata} width="80px" alt="No data" /><br />
                                                                    <span style={{ color: '#888', marginTop: '10px', display: 'inline-block' }}>No Location History Found</span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {filtered.length > locationPageSize && (
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                                                    <Pagination
                                                        count={Math.ceil(filtered.length / locationPageSize)}
                                                        page={locationPage}
                                                        onChange={(e, val) => setLocationPage(val)}
                                                        color="success"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                )}

                {activeMainTab === 'contacts' && (
                    <div className="animated fadeIn" style={{ padding: '15px' }}>
                        {contactsLoader ? (
                            <div className="text-center" style={{ padding: '50px' }}>
                                <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ color: '#2B78FF' }}></i>
                                <p style={{ marginTop: '10px', color: '#555' }}>Loading Contacts...</p>
                            </div>
                        ) : (
                            <div>
                                {(() => {
                                    const contacts = contactsData ? (contactsData.data || []) : [];
                                    const filtered = contacts.filter(item => {
                                        const name = item.name || '';
                                        const number = item.number || '';
                                        const type = item.type || '';
                                        const term = contactSearch.toLowerCase();
                                        return name.toLowerCase().includes(term) || number.toLowerCase().includes(term) || type.toLowerCase().includes(term);
                                    });

                                    return (
                                        <div>
                                            <div className="row" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search contacts on this page..."
                                                        value={contactSearch}
                                                        onChange={(e) => {
                                                            setContactSearch(e.target.value);
                                                        }}
                                                        style={{
                                                            borderRadius: '8px',
                                                            border: '1px solid #D3D9E9',
                                                            padding: '10px 15px',
                                                            width: '100%',
                                                            maxWidth: '400px'
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-sm-6 text-right">
                                                    <span style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>
                                                        Total Contacts: <b>{contactsData ? contactsData.totalCount : 0}</b>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="phocket-table-new">
                                                <table>
                                                    <thead>
                                                        <tr className="thead-class">
                                                            <th>Contact Name</th>
                                                            <th>Phone Number</th>
                                                            <th>Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filtered.length > 0 ? (
                                                            filtered.map((item, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ fontWeight: '600', color: '#333' }}>{item.name || 'N/A'}</td>
                                                                        <td style={{ color: '#2B78FF', fontWeight: '500' }}>{item.number || 'N/A'}</td>
                                                                        <td>
                                                                            <span style={{
                                                                                padding: '3px 8px',
                                                                                borderRadius: '10px',
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                background: '#EAEAEA',
                                                                                color: '#333'
                                                                            }}>
                                                                                {item.type || 'N/A'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center" style={{ padding: '40px' }}>
                                                                    <img src={Nodata} width="80px" alt="No data" /><br />
                                                                    <span style={{ color: '#888', marginTop: '10px', display: 'inline-block' }}>No Contacts Found</span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {contactsData && contactsData.totalPages > 1 && (
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                                                    <Pagination
                                                        count={contactsData.totalPages}
                                                        page={contactPage}
                                                        onChange={(e, val) => setContactPage(val)}
                                                        color="success"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                )}

                {activeMainTab === 'callLogs' && (
                    <div className="animated fadeIn" style={{ padding: '15px' }}>
                        {callLogsLoader ? (
                            <div className="text-center" style={{ padding: '50px' }}>
                                <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ color: '#2B78FF' }}></i>
                                <span className="sr-only">Loading...</span>
                                <p style={{ marginTop: '10px', color: '#555' }}>Fetching Call Logs...</p>
                            </div>
                        ) : (
                            <div>
                                {(() => {
                                    const callLogsList = callLogsData ? (callLogsData.data || []) : [];

                                    const filteredCallLogs = callLogsList.filter(item => {
                                        const fields = getCallLogFields(item);
                                        const term = callLogSearch.toLowerCase();
                                        return fields.contact.toLowerCase().includes(term) || fields.type.toLowerCase().includes(term);
                                    });

                                    return (
                                        <div>
                                            <div className="row" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by Name or Number..."
                                                        value={callLogSearch}
                                                        onChange={(e) => {
                                                            setCallLogSearch(e.target.value);
                                                        }}
                                                        style={{
                                                            borderRadius: '8px',
                                                            border: '1px solid #D3D9E9',
                                                            padding: '10px 15px',
                                                            width: '100%',
                                                            maxWidth: '400px'
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-sm-6 text-right">
                                                    <span style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>
                                                        Total Logs: <b>{callLogsData ? callLogsData.totalCount : 0}</b>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="phocket-table-new">
                                                <table>
                                                    <thead>
                                                        <tr className="thead-class">
                                                            <th>Contact Name / Number</th>
                                                            <th>Call Type</th>
                                                            <th>Duration</th>
                                                            <th>Date & Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredCallLogs.length > 0 ? (
                                                            filteredCallLogs.map((item, i) => {
                                                                const fields = getCallLogFields(item);
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ fontWeight: '600', color: '#333' }}>{fields.contact}</td>
                                                                        <td>
                                                                            <span style={{
                                                                                padding: '4px 8px',
                                                                                borderRadius: '12px',
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                textTransform: 'uppercase',
                                                                                background: fields.type.toLowerCase().includes('incoming') ? '#E2F0D9' :
                                                                                            fields.type.toLowerCase().includes('outgoing') ? '#FFF2CC' :
                                                                                            fields.type.toLowerCase().includes('missed') ? '#FCE4D6' : '#EAEAEA',
                                                                                color: fields.type.toLowerCase().includes('incoming') ? '#385723' :
                                                                                       fields.type.toLowerCase().includes('outgoing') ? '#7F6000' :
                                                                                       fields.type.toLowerCase().includes('missed') ? '#C65911' : '#333'
                                                                            }}>
                                                                                {fields.type}
                                                                            </span>
                                                                        </td>
                                                                        <td>{fields.duration} {isNaN(Number(fields.duration)) ? '' : 'Sec'}</td>
                                                                        <td>{formatCallDate(fields.date)}</td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" className="text-center" style={{ padding: '40px' }}>
                                                                    <img src={Nodata} width="80px" alt="No data" /><br />
                                                                    <span style={{ color: '#888', marginTop: '10px', display: 'inline-block' }}>No Call Logs Found</span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {callLogsData && callLogsData.totalPages > 1 && (
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                                                    <Pagination
                                                        count={callLogsData.totalPages}
                                                        page={callLogPage}
                                                        onChange={(e, val) => setCallLogPage(val)}
                                                        color="success"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
export default SmsAnalysis